import { TextAUnderlineIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const UnderlinedA = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextAUnderlineIcon {...rest} size={Sizes[size]} color={fill} />;
};

UnderlinedA.displayName = 'UnderlinedA';
